module.exports = __webpack_public_path__ + "static/media/es.361eda2a.svg";